// Module
var code = ` <span title="{{ \$ctrl.state }}"><span ng-bind-html="\$ctrl.stateDesc | saltosLinea"></span></span> `;
// Exports
module.exports = code;